import * as React from 'react';

import {formatTimestampForTimelineHeader} from 'nutshell-core/date-time/formatting';

import {Avatar} from 'shells/avatar/avatar';

import styles from './avatar-with-time.module.css';

type Props = {
    avatarUrl?: string;
    initials?: string;
    sentTime: number | null | undefined;
};

export const AvatarWithTime = (props: Props) => {
    const {avatarUrl, initials, sentTime} = props;

    // @ts-expect-error
    const getFormattedDate = (time) => {
        const date = formatTimestampForTimelineHeader(time);
        const month = date.slice(0, 4);
        const uppercaseMonth = month.toUpperCase();
        const formattedDate = date.replace(month, uppercaseMonth);

        return formattedDate;
    };

    return (
        <div className={styles['avatar-time-container']}>
            <div>
                <Avatar type='users' size={32} avatarUrl={avatarUrl} initials={initials} />
            </div>
            {sentTime ? (
                <div className={styles['date-container']}>{getFormattedDate(sentTime)}</div>
            ) : null}
        </div>
    );
};
